import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TicketElement} from '../../../../../../projects/shared-lib/src/lib/models/ticket-element';
import {MailCategory} from '../../../../../../projects/shared-lib/src/lib/models/ticket-detail-token';
import {TicketsService} from '../../../tickets.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ClientTicketHeaderComponent } from '../client-ticket-header/client-ticket-header.component';
import { HideByEnvironmentDirective } from '../../../../shared/directive/hide-byenvironment.directive';
import { ClientTicketDetailsComponent } from '../client-ticket-details/client-ticket-details.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TwGoogleMaps } from '../../../../shared/pipe/tw-url-googlemaps/tw-googleMaps.pipe';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from '../../../../../../projects/shared-lib/src/lib/component/message/confirm-dialog/confirm-dialog.component';


@Component({
    selector: 'tw-client-ticket-detail',
    templateUrl: './client-ticket-detail.component.html',
    styleUrls: ['./client-ticket-detail.component.css'],
    imports: [ClientTicketHeaderComponent, HideByEnvironmentDirective, ClientTicketDetailsComponent, MatButton, MatIcon, TranslatePipe, TwGoogleMaps]
})
export class ClientTicketDetailComponent implements OnInit {
    @Input() ticketElement: TicketElement;
    @Output() displayPdf: EventEmitter<string> = new EventEmitter<string>();
    displayDetails = false;
    ticketsFileUrl: string;
    seatsFileUrl: string;
    filename: string;

    constructor(private ticketService: TicketsService,
                private translateService: TranslateService,
                private dialog: MatDialog) {
    }

    ngOnInit() {
    }

    displayPdfFile(url: string) {
        this.displayPdf.emit(url);
    }

    getMailTypes() {
        return Object.keys(MailCategory);
    }

    isPrintableCategory(category: MailCategory|string) {
        return category === MailCategory.E_TICKETS || category === MailCategory.SMARTPHONE;
    }

    hasGiftedTickets(mail: MailCategory|string): boolean {
        if (!this.ticketElement.pricesByMail[mail]) {
            return false;
        }
        return this.ticketElement.pricesByMail[mail].some((el: { upcomingTicketDetailTokens: any[]; }) => {
            return el.upcomingTicketDetailTokens.some(token => token.giftRecipient);
        });
    }

    printTickets(mail: MailCategory|string) {
        const hasGifted = this.hasGiftedTickets(mail);

        if (hasGifted) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                data: <ConfirmDialogData>{
                    message: this.translateService.instant('client.tickets.printWarningMessage'),
                    confirmText: this.translateService.instant('client.tickets.ok'),
                    cancelText: this.translateService.instant('client.tickets.cancel'),
                }
            });
            dialogRef.afterClosed().subscribe((confirmed) => {
                if (confirmed) {
                    this.executePrintTickets(mail);
                }
            });
        } else {
            this.executePrintTickets(mail);
        }
    }

    private executePrintTickets(mail: MailCategory|string) {
        this.displayDetails = true;
        if (!this.ticketsFileUrl) {
            const sodIds: number[] = [];
            this.ticketElement.pricesByMail[mail].forEach((el: { upcomingTicketDetailTokens: any[]; }) => {
                el.upcomingTicketDetailTokens.forEach(token => {
                    // only include tickets that haven't been gifted
                    if (!token.giftRecipient) {
                        sodIds.push(token.sodId);
                    }
                });
            });
            this.ticketService.getTicketsPdfForSodIds(sodIds, mail).subscribe((pdf) => {
                this.ticketsFileUrl = URL.createObjectURL(pdf);
                this.displayPdf.emit(this.ticketsFileUrl);
            });
        } else {
            this.displayPdf.emit(this.ticketsFileUrl);
        }
    }

    detailSeats(mail: MailCategory|string) {
        this.displayDetails = true;
        if (!this.seatsFileUrl) {
            const seatIds: number[] = [];
            this.ticketElement.pricesByMail[mail].forEach(el => {
                el.upcomingTicketDetailTokens.forEach(token => {
                    seatIds.push(token.seat.dispositionDetailId);
                });
            });
            this.ticketService
                .getSeatsPdfForEventAndDDId(
                    this.ticketElement.pricesByMail[mail][0].eventId,
                    seatIds,
                )
                .subscribe((pdf) => {
                    this.seatsFileUrl = URL.createObjectURL(pdf);
                    this.displayPdf.emit(this.seatsFileUrl);
                });
        } else {
            this.displayPdf.emit(this.seatsFileUrl);
        }
    }


    addToGoogleWallet(mail: MailCategory|string) {
        const prices = this.ticketElement.pricesByMail[mail];
        this.ticketService.getGoogleWalletLink(prices[0].addToGoogleWalletLink)
            .subscribe(link => {
                window.open(link.replace(/['"]+/g, ''), '_blank');
            });

    }

    addToAppleWallet(mail: MailCategory|string) {
        const prices = this.ticketElement.pricesByMail[mail];
        this.ticketService.getAppleWalletLink(prices[0].addToAppleWalletLink)
            .subscribe(blob => {
                const fileName = this.generatePKPassesFileName(prices[0].addToAppleWalletLink);
                const url = URL.createObjectURL(blob);
                this.downloadFile(url, fileName);
            });
    }

    generatePKPassesFileName(filename: string) {
        const regExp = /(?<=apple\/)(.*)(?=\?token)/;
        return filename.match(regExp)?.pop();
    }

    downloadFile(url: string, fileName: string) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
        URL.revokeObjectURL(url);
    }

    getCurrentLanguage(): string {
        return this.translateService.currentLang;
    }

}
